import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommentsIcon from 'Components/Icons/Comments';
import Label from 'Components/Label';
import ProgressBar from 'Components/ProgressBar';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ConversacionesService from 'Services/Http/Conversaciones.service';

const ListarPreguntas = (props) => {
  const { idExpediente, type } = props;
  const [loader, setLoader] = useState();
  const [data, setData] = useState([]);
  const [showBotton, setShowBotton] = useState(false);
  const [showComponent, setShowComponente] = useState(false);
  const telefonos = useSelector((state) => state.telefonos?.telefonos);
  const findData = async () => {
    setData([]);
    setLoader(true);
    setShowComponente(false);
    try {
      const phonesList = type === '1' ? telefonos.cliente : telefonos.aval;
      const phone = phonesList[0].movil;
      const respuestas = await ConversacionesService.getConverasion(idExpediente, type, phone);
      createRows(respuestas.data);
    } catch (e) {
      console.log(e);
    }
  };
  const createSubRows = (text) => {
    const rows = text.split('|');
    let data = rows.map((item, index) => (
      <div
        key={'clientes-row-' + index}
        className="odd:bg-white odd:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer p-2">
        {item || ''}
      </div>
    ));
    return data;
  };
  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'clientes-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td className="px-6 py-4 w-1/2">{item.txtPregunta || ''}</td>
        <td className="px-6 py-4 w-1/2">{createSubRows(item.respuesta_unida) || ''}</td>
      </tr>
    ));
    let idxActive = [...new Set([...rows.map((item) => item.active === 1)])];
    if (idxActive.includes(true)) {
      setShowBotton(true);
    }
    if (data.length > 0) {
      setShowComponente(true);
    }
    setData(data);
    setLoader(false);
  };
  useEffect(() => {
    findData();
  }, [telefonos]);
  return showComponent ? (
    <>
      <Label text={'Solicitudes a Validar'} />
      <div className="flex justify-end my-2 gap-2">
        {showBotton ? (
          <button
            onClick={() => findData()}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            <FontAwesomeIcon icon={['fa', 'sync']} />
          </button>
        ) : null}
        <button
          onClick={() => findData()}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
          <CommentsIcon className="text-white size-6" />
        </button>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                Pregunta
              </th>
              <th scope="col" className="px-6 py-3">
                Respuesta
              </th>
            </tr>
          </thead>
          <tbody>{data}</tbody>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
    </>
  ) : (
    ''
  );
};

ListarPreguntas.propTypes = {
  idExpediente: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired
};

export default ListarPreguntas;
